import {Routes} from '@angular/router';
import {QuizComponent} from '@app/components/quiz/quiz.component';
import {EventComponent} from '@app/components/event/event.component';

export const routes: Routes = [
  {
    path: '',
    component: QuizComponent
  },
  {
    path: 'event',
    component: EventComponent
  },
  {
    path: '**',
    redirectTo: ``
  },
];
